import { gql } from "@apollo/client";

export default gql`
  mutation setAccountSetupRelationshipsMutation(
    $organizationId: Int!
    $relationships: [RelationshipInput]
    $userId: Int!
    $invitations: [InvitationInput]!
    $saveRelationships: Boolean!
  ) {
    setRelationships(
      organizationId: $organizationId
      relationships: $relationships
      userId: $userId
    ) @include(if: $saveRelationships) {
      me {
        id
      }
    }
    createInvitations(invitationRequests: $invitations) {
      invitationErrors {
        inviteeEmail
        message
      }
    }
  }
`;
